export const REGISTER_URL = "/register/private";
export const REGISTER_B2B_URL = "/register/business";

export const TYPE_DEBOUNCE = 500;
